import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileResumeContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return !!contextType && contextType === SharedFileRequestContextType.Resume;
}
